export const formattedCatalogEntryCarouselId = (id: string) => id.toUpperCase();
